import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { RefreshCw } from 'lucide-react';
import App from './App.tsx';
import './index.css';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initializeMonitoring } from './lib/monitoring';

// Initialize monitoring
initializeMonitoring();

// Wrap App with Sentry error boundary
const SentryErrorBoundary = Sentry.withErrorBoundary(ErrorBoundary, {
  fallback: ({ error }) => (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="glass-panel-glow rounded-xl p-8 max-w-md w-full text-center">
        <h2 className="text-2xl font-display font-bold text-slate-100 mb-4">
          Oops, something went wrong
        </h2>
        <p className="text-slate-300 mb-6">
          {error?.message || 'An unexpected error occurred'}
        </p>
        <button
          onClick={() => window.location.reload()}
          className="btn-primary inline-flex items-center space-x-2"
        >
          <RefreshCw className="w-4 h-4" />
          <span>Try Again</span>
        </button>
      </div>
    </div>
  ),
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundary>
      <App />
    </SentryErrorBoundary>
  </StrictMode>
);